// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"fcd53586","438":"bfa43d96","492":"e592af95","536":"8f48ac30","538":"fad62357","584":"5560322b","941":"8ac8fd0a"}[chunkId] + ".chunk.js";
};